import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { publicApi, setToken, API } from "@/lib/api";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const { data } = await publicApi.post(`${API}/admin/login`, { password });
      setToken(data.token);
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid password");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen relative overflow-hidden bg-[#050505] text-white flex items-center justify-center px-4">
      <div
        className="absolute inset-0 opacity-25 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1763645246808-79c2c51d86ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZXN0YXVyYW50JTIwZGFyayUyMGFtYmlhbmNlfGVufDB8fHx8MTc3NzI1NTc1N3ww&ixlib=rb-4.1.0&q=85')",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/85 to-[#050505]" />

      <div className="relative w-full max-w-md fade-up">
        <div className="text-center mb-10">
          <Logo size="lg" />
          <div className="mt-3 text-xs uppercase tracking-[0.4em] text-white/50">
            Catering Contracts · Admin
          </div>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#0d0d0d]/80 backdrop-blur border border-white/10 p-8 sm:p-10 gold-glow"
          data-testid="admin-login-form"
        >
          <div className="flex items-center gap-2 mb-6 text-[#C9963F]">
            <Lock size={16} strokeWidth={1.5} />
            <span className="text-xs uppercase tracking-[0.3em]">Admin Access</span>
          </div>

          <label className="block text-[10px] uppercase tracking-[0.2em] text-white/60 mb-2">
            Master Password
          </label>
          <div className="relative">
            <input
              type={show ? "text" : "password"}
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-transparent border-b border-white/20 px-0 py-3 pr-10 focus:border-[#C9963F] focus:outline-none transition-colors text-white placeholder-white/30 tracking-wider"
              placeholder="••••••••••"
            />
            <button
              type="button"
              onClick={() => setShow(!show)}
              data-testid="toggle-password-visibility"
              className="absolute right-0 top-1/2 -translate-y-1/2 text-white/50 hover:text-[#C9963F]"
              aria-label="Toggle password visibility"
            >
              {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-8 w-full bg-[#C9963F] text-black font-medium tracking-wide py-3 hover:bg-[#A67A2D] transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Enter Dashboard"}
          </button>

          <div className="mt-6 text-[10px] text-white/40 text-center tracking-wide">
            Single master password. Sessions persist for 7 days.
          </div>
        </form>

        <div className="text-center mt-8 text-[10px] uppercase tracking-[0.3em] text-white/30">
          4707 State Hwy 121 · The Colony, TX
        </div>
      </div>
    </div>
  );
}
